"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmailSafeFontFamily = exports.getEmailFontFamilyCss = exports.EMAIL_FONT_FAMILY_CSS = exports.EMOJI_FONT_FAMILY_FALLBACK = void 0;
const emails_1 = require("../constants/emails");
const WAYPOINT_NATIVE_FONT_FAMILY_CSS = {
    MODERN_SANS: '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif',
    BOOK_SANS: 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif',
    ORGANIC_SANS: 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif',
    GEOMETRIC_SANS: 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif',
    HEAVY_SANS: 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif',
    ROUNDED_SANS: 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif',
    MODERN_SERIF: 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif',
    BOOK_SERIF: '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif',
    MONOSPACE: '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace',
};
exports.EMOJI_FONT_FAMILY_FALLBACK = '"Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji"';
const withEmojiFallback = (fontFamilyStack) => `${fontFamilyStack}, ${exports.EMOJI_FONT_FAMILY_FALLBACK}`;
const EMAIL_SAFE_FONT_FAMILY_CSS = {
    ARIAL: withEmojiFallback("Arial, Helvetica, sans-serif"),
    CENTURY_GOTHIC: withEmojiFallback('"Century Gothic", "Gill Sans", Calibri, sans-serif'),
    COURIER_NEW: withEmojiFallback('"Courier New", Courier, monospace'),
    GEORGIA: withEmojiFallback('Georgia, "Times New Roman", serif'),
    IMPACT: withEmojiFallback('Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif'),
    PALATINO: withEmojiFallback('Palatino, "Palatino Linotype", "Book Antiqua", Georgia, serif'),
    TAHOMA: withEmojiFallback("Tahoma, Geneva, sans-serif"),
    TIMES_NEW_ROMAN: withEmojiFallback('"Times New Roman", Times, serif'),
    TREBUCHET_MS: withEmojiFallback('"Trebuchet MS", Tahoma, sans-serif'),
    VERDANA: withEmojiFallback("Verdana, Geneva, sans-serif"),
};
exports.EMAIL_FONT_FAMILY_CSS = {
    ...WAYPOINT_NATIVE_FONT_FAMILY_CSS,
    ...EMAIL_SAFE_FONT_FAMILY_CSS,
};
const EMAIL_SAFE_FONT_FAMILY_TOKENS = new Set(emails_1.EMAIL_SAFE_FONT_FAMILIES);
const getEmailFontFamilyCss = (fontFamily) => {
    if (!fontFamily) {
        return undefined;
    }
    return exports.EMAIL_FONT_FAMILY_CSS[fontFamily];
};
exports.getEmailFontFamilyCss = getEmailFontFamilyCss;
const isEmailSafeFontFamily = (fontFamily) => typeof fontFamily === "string" && EMAIL_SAFE_FONT_FAMILY_TOKENS.has(fontFamily);
exports.isEmailSafeFontFamily = isEmailSafeFontFamily;
